module.exports = __webpack_public_path__ + "static/media/youzan-active.0a65c125.png";